import { VIEWPORT_MOBILE_DESKTOP_UI_CONTENT, VIEWPORT_MOBILE_PAGE_CONTENT } from './constants';

export const resolveViewportMetaContent = (params: {
    devicePlatform: 'desktop' | 'mobile';
    showMobileView: boolean;
}): string | undefined => {
    if (params.devicePlatform === 'desktop') {
        return undefined;
    }

    return params.showMobileView ? VIEWPORT_MOBILE_PAGE_CONTENT : VIEWPORT_MOBILE_DESKTOP_UI_CONTENT;
};
